import useDataTree from '@opsbase/web-ctrl-datatree/useDataTree';
import React from 'react';
import { useReportCSS } from '../useReportCSS';
import ViewReportDataTableGroup from './ViewReportDataTableGroup';
export function ViewReportGroupData() {
    var _a;
    const dt = useDataTree();
    const myCss = useReportCSS(true);
    if ((_a = dt.rootNode.childNodes) === null || _a === void 0 ? void 0 : _a.length) {
        return (React.createElement("div", { className: myCss.page2 },
            React.createElement("table", { className: myCss.table },
                React.createElement("tbody", null,
                    React.createElement("tr", { className: myCss.row },
                        React.createElement("th", { className: myCss.heading }, "Group Name"),
                        React.createElement("th", { className: myCss.heading }, "Count")),
                    dt.rootNode.childNodes.map(childNode => {
                        var _a, _b, _c, _d, _e, _f;
                        return (React.createElement(React.Fragment, null,
                            React.createElement("tr", { className: myCss.row },
                                React.createElement("td", { className: myCss.data },
                                    React.createElement("div", { className: myCss.heading1nomargin, style: { color: (_b = (_a = childNode.group) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.main } }, (_c = childNode.group) === null || _c === void 0 ? void 0 : _c.title)),
                                React.createElement("td", { className: myCss.data }, ((_d = childNode.itemCollection) === null || _d === void 0 ? void 0 : _d.totalCount) ||
                                    ((_e = childNode.childNodes) === null || _e === void 0 ? void 0 : _e.reduce((acc, v) => acc + v.itemCollection.totalCount, 0)))), (_f = childNode.childNodes) === null || _f === void 0 ? void 0 :
                            _f.map(grandChildNode => {
                                var _a, _b, _c, _d;
                                return (React.createElement("tr", { className: myCss.row },
                                    React.createElement("td", { className: myCss.data },
                                        React.createElement("div", { className: myCss.heading1nomargin, style: {
                                                paddingLeft: 50,
                                                color: (_b = (_a = grandChildNode.group) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.main,
                                            } }, (_c = grandChildNode.group) === null || _c === void 0 ? void 0 : _c.title)),
                                    React.createElement("td", { className: myCss.data }, (_d = grandChildNode.itemCollection) === null || _d === void 0 ? void 0 : _d.totalCount)));
                            })));
                    })))));
    }
    return React.createElement(ViewReportDataTableGroup, { nodeKey: dt.rootNode.nodeKey });
}
export default ViewReportGroupData;
